export const isUserAgentFirefox = (userAgent: string | null) => {
  return userAgent?.includes("Firefox");
};
